const fuzzyExpertFilter = (searchquery) => (expert) => {
    const search = searchquery.toLowerCase();
    return expert.name.toLowerCase().includes(search)
        || expert.about.toLowerCase().includes(search)
        || String(expert.age).includes(search)
}

export { fuzzyExpertFilter };